import { React } from "react";
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'


const Layout = () => {
    if(String(localStorage.getItem("company_nm")) === 'MES'){
        document.title = "MES";
    }else{
        document.title = String(localStorage.getItem("company_nm")) + " MES";
    }
    return (
        <div>
            <Header />
            <Footer />
        </div>
    )
}

export default Layout